"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsWithOtherNodesDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const action_dialog_styles_1 = require("../../../../../generic/action-dialog/action-dialog.styles");
const product_tree_node_list_1 = require("../product-tree-node-list");
const actions_with_other_nodes_styles_1 = require("./actions-with-other-nodes.styles");
const components_1 = require("../../../../../components");
const generic_1 = require("../../../../../generic");
const localization_1 = require("../../../../../../localization");
const ActionsWithOtherNodesDialog = ({ title, message, productTreeNodeFilter, successSingleActionCompleteTitle, error, isLoading, attributesFilter, renderTreeNodeSecondaryText, onSubmit, onClose, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [selectedTreeNodeIds, setSelectedTreeNodeIds] = (0, react_1.useState)([]);
    const handleSubmit = () => onSubmit(selectedTreeNodeIds);
    return (react_1.default.createElement(action_dialog_styles_1.StyledActionDialog, { open: true, title: title, proceedButtonProps: {
            error,
            disabled: !selectedTreeNodeIds.length || isLoading,
            title: error ? t({ key: 'DELETE' }) : t({ key: 'ADD' }),
            onClick: handleSubmit,
            endIcon: isLoading && react_1.default.createElement(generic_1.LoadingIndicator, null),
        }, cancelButtonProps: { title: t({ key: 'SKIP' }), onClick: onClose } }, react_1.default.createElement(action_dialog_styles_1.StyledActionDialogContainer, null, react_1.default.createElement(actions_with_other_nodes_styles_1.StyledDeleteDialogContent, null, react_1.default.createElement(components_1.Alert, { severity: "success", variant: "outlined" }, successSingleActionCompleteTitle), message && react_1.default.createElement(ui_components_1.Typography, { variant: "caption", color: "textSecondary" }, message), react_1.default.createElement(product_tree_node_list_1.ProductTreeNodeList, { filter: productTreeNodeFilter, attributesFilter: attributesFilter, selectedItems: selectedTreeNodeIds, onSelect: setSelectedTreeNodeIds, renderSecondaryTitleText: renderTreeNodeSecondaryText })))));
};
exports.ActionsWithOtherNodesDialog = ActionsWithOtherNodesDialog;
exports.default = exports.ActionsWithOtherNodesDialog;
